import { useCurrentModule } from './ModuleProvider';

/**
 * Mounts above the routed page tree to fire `useFetchProductDescription`
 * as early as possible — so by the time the SelectPlan page renders, the
 * query is already in flight (and ideally resolved) and `ProductCard`
 * descriptions don't flicker between the legacy/plan text and the dealer
 * one. Same query key as the call inside `useProductDescription`, so
 * react-query dedupes; only one network request fires per session.
 *
 * Gated on the `useDealerDescriptions` experiment so users in the control
 * group don't hit the new endpoint.
 *
 * Renders nothing. Must be mounted inside `<ApisClientProvider>` and after
 * the p3Context has been set on the eclipse offering context (i.e. inside
 * the module Provider's return tree).
 */
export const DealerDescriptionsPrefetch = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isUseDealerDescriptions = experiments.isEnabled('specs.premium.useDealerDescriptions');
  module.SDK.eclipseOfferingApiClient.hooks.useFetchProductDescription({}, isUseDealerDescriptions);
  return null;
};
//# sourceMappingURL=DealerDescriptionsPrefetch.js.map